import { Informational } from 'components/Informational';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { useContext, useEffect } from 'react';

export const About = (): JSX.Element => {
  const { setTitle, showNavigationButtons, showUserProfile } = useContext(MainLayoutContext);
  const { navigateBack } = useAppNavigation();

  useEffect(() => {
    setTitle('Account');
    showNavigationButtons(true);
    showUserProfile(true);
  }, [setTitle, showNavigationButtons, showUserProfile]);

  return (
    <Informational title={'About Global Home Technologies'} onCancel={navigateBack}>
      <>
        <p>
          MyGlobalHome is reinventing the understanding of what constitutes a smart home. Currently
          there are no national or global standards, ideas range from voice control blinds,
          controllable lighting to energy metering.
        </p>
        <p>
          MyGlobalHome is the first real ‘operating system’ for the home, it makes the home actually
          smart and report on its performance and optimises itself to function at its most efficient
          according to the occupants needs.
        </p>
        <p>“A home should look after its occupant, not the other way around”. Lee McCormack.</p>
        <p>For Occupants</p>
        <p>Lighting Control: Create mood lighting, dim individual zones, create pre-sets</p>
        <p>
          Heating Control: Intelligent room and environmental analysis reduces energy wastage and
          improves comfort
        </p>
        <p>
          Automation: Environmental intelligence enables automated blind and curtain shading to
          maintain optimal internal conditions
        </p>
        <p>
          Energy Control: Intelligent understanding of the occupants needs to reduce energy wastage
        </p>
        <p>
          Environmental: Internal and external environmental monitoring underpins optimal air
          quality conditioning and heating control
        </p>
        <p>
          MyGlobalHome is seeking to provide homes that are more sustainable and healthier for the
          occupants that live in them. MyGlobalHome’s software provides occupants and building
          managers with control of heating, lighting, and automation as standard. Additionally,
          MyGlobalHome’s software provides energy monitoring and optimisation to reduce operating
          costs and environmental sensing to optimise internal wellness through better air quality.
        </p>
      </>
    </Informational>
  );
};
